<template>
  <span :class="classes">
    <span v-if="!imgSrc" :class="`${prefixAvatarClass}__text`">{{ text }}</span>
    <img v-else :class="`${prefixAvatarClass}__img`" :src="imgSrc">
    <i v-if="dot" :class="`${prefixAvatarClass}__dot`"></i>
  </span>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIX_AVATAR_CLASS = `${PREFIX_CLASS}avatar`

export default {
  props: {
    dot: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      validator(value) {
        return ['', 'sm'].includes(value)
      },
      default: ''
    },
    dotState: {
      type: String,
      validator(value) {
        return ['success', 'danger', 'warning', 'primary', 'info'].includes(value)
      },
      default: 'danger'
    },
    bgState: {
      type: String,
      validator(value) {
        return ['', 'success', 'danger', 'warning', 'primary', 'info'].includes(value)
      },
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    prefixAvatarClass() {
      return PREFIX_AVATAR_CLASS
    },
    classes() {
      return [
        `${this.prefixAvatarClass}`,
        {
          [`bg-${this.bgState}`]: !!this.bgState,
          [`${this.prefixAvatarClass}--${this.dotState}`]:
            this.dot && !!this.dotState,
          [`${this.prefixAvatarClass}--sm`]: this.size === 'sm'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// avatar.vue?36036e20